exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js!react-horizontal-scrolling-menu/dist/styles.css"), "");

// module
exports.push([module.id, "\n", ""]);

// exports
